// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#changeReviewModal .btn {
  border-radius: 30px;
  min-width: 115px;
  box-shadow: none !important;
}
#changeReviewModal textarea::placeholder {
  color: #adadad;
  opacity: 0.65;
}
#changeReviewModal .multiselect__placeholder {
  color: #adadad;
  opacity: 0.65;
}
#changeReviewModal .btn-link {
  color: #5b5b5b;
  font-weight: bold;
}
#changeReviewModal .btn-link:hover {
  text-decoration: none;
  color: #5a5a5a;
}
#changeReviewModal .btn-link:focus {
  text-decoration: none;
}
#changeReviewModal .btn-secondary {
  border-radius: 30px;
  min-width: 115px;
  background-color: #b4b4b4;
  box-shadow: none !important;
}
#changeReviewModal .btn-primary {
  border-radius: 30px;
  min-width: 115px;
  box-shadow: none !important;
}
#changeReviewModal .multiselect__select {
  height: 41px;
}
@media (min-width: 2024px) {
#changeReviewModal #confirmation-modal-label {
    font-size: 3.2rem;
}
}
#changeReviewModal .invalid-feedback {
  display: block;
}
@media (min-width: 2024px) {
#changeReviewModal .invalid-feedback span {
    font-size: 1.84rem !important;
}
}
@media (min-width: 2024px) {
#changeReviewModal .modal-dialog {
    max-width: 700px !important;
}
}
@media (min-width: 768px) {
#changeReviewModal .modal-dialog {
    max-width: 600px !important;
}
}
@media (min-width: 2024px) {
#changeReviewModal .modal-dialog .input-group input {
    font-size: 1.84rem !important;
}
}
#changeReviewModal .modal-dialog .wrapper-icon {
  position: relative;
  left: 5px;
  top: -2px;
}
#changeReviewModal .modal-dialog .wrapper-icon .icon-info {
  border: 2px solid #adadad;
  padding: 3px;
  font-size: 20px;
  border-radius: 20px;
  width: 20px;
  color: #adadad;
  cursor: pointer;
}
@media (min-width: 2024px) {
#changeReviewModal .modal-dialog .modal-footer button.btn {
    font-size: 1.84rem !important;
}
}`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
